import React, { Component } from 'react'
import EQuotePackageStateRoomsSlider from './EQuotePackageStateRoomsSlider'
import StateRoomCard from './StateRoomCard'
import TermsAndConditions from '../terms/TermsAndConditions'

import '../../styles/scss/components/equote-package-staterooms.scss'

const stateRoomOrder = ['I', 'O', 'B', 'D']

const imgHeights = {
  // $bp-max-xs: 'max-width: 320px';
  // $bp-max-sm: 'max-width: 480px';
  // $bp-max-md: 'max-width: 768px';
  // $bp-max-lg: 'max-width: 1024px';
  // $bp-max-xl: 'max-width: 1180px';
  // $bp-max-xxl: 'max-width: 1920px';
  // we use the carousel view up to $bp-max-xlr

  z: {
    'xx-large': 220,
    'x-large': 200,
    large: 222,
    medium: 225,
    small: 150,
    'x-small': 125
  },
  r: {
    'xx-large': 222,
    'x-large': 222,
    large: 350,
    medium: 350,
    small: 300,
    'x-small': 200
  },
  c: {
    'xx-large': 222,
    'x-large': 200,
    large: 220,
    medium: 300,
    small: 225,
    'x-small': 150
  }
}

const renderTables = (stateRooms, props, sizing, isCarouselView) => {
  const imgHeight = props.brand ? imgHeights[props.brand][sizing] : null
  if (!stateRooms) {
    return null
  }

  return stateRooms.map((room, i) => {
    return (
      <StateRoomCard
        key={`${room.stateroom.name}-${i}`}
        sizing={sizing}
        stateRoom={room}
        imgHeight={imgHeight}
        brand={props.brand}
        qualifiers={props.searchParameters}
        isCarouselView={isCarouselView}
        currency={props.currency}
        currencySymbol={props.currencySymbol}
        currencySymbolPlacement={props.currencySymbolPlacement}
        openVirtualTour={props.openVirtualTour}
        brandClassName={props.brandClassName}
      />
    )
  })
}

class EQuotePackageStateRooms extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sizing: 'large'
    }

    this.getStateRoomImageSize = this.getStateRoomImageSize.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.getStateRoomImageSize)
    this.getStateRoomImageSize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getStateRoomImageSize)
  }

  getStateRoomImageSize = () => {
    switch (true) {
      case window.innerWidth >= 1405:
        this.setState({
          sizing: 'xx-large'
        })
        break
      case window.innerWidth >= 1180:
        this.setState({
          sizing: 'x-large'
        })
        break
      case window.innerWidth >= 1024:
        this.setState({
          sizing: 'large'
        })
        break
      case window.innerWidth >= 768:
        this.setState({
          sizing: 'medium'
        })
        break
      case window.innerWidth >= 480:
        this.setState({
          sizing: 'small'
        })
        break
      default:
        this.setState({
          sizing: 'x-small'
        })
    }

    // $bp-max-xs: 'max-width: 320px';
    // $bp-max-sm: 'max-width: 480px';
    // $bp-max-md: 'max-width: 768px';
    // $bp-max-lg: 'max-width: 1024px';
    // $bp-max-xl: 'max-width: 1180px';
    // $bp-max-xxl: 'max-width: 1920px';
  }

  render() {
    const {
      activePackage,
      searchParameters,
      brandClassName,
      openVirtualTour
    } = this.props

    const stateRooms =
      activePackage &&
      activePackage.stateRoomData &&
      activePackage.stateRoomData.selectedStateRooms
        ? activePackage.stateRoomData.selectedStateRooms.sort((a, b) => {
            if (a.superCategoryCode === b.superCategoryCode) {
              return a.netPrice < b.netPrice ? -1 : 1
            }
            return stateRoomOrder.indexOf(a.superCategoryCode) <
              stateRoomOrder.indexOf(b.superCategoryCode)
              ? -1
              : 1
          })
        : null

    const brand = activePackage.brand ? activePackage.brand.toLowerCase() : null
    const currency = activePackage.currency ? activePackage.currency : 'USD'

    return (
      <div
        className="equote-package-state-rooms u-content-container"
        id="staterooms"
      >
        <h1 className={`section-title ${brandClassName} u-text-center`}>
          Available Staterooms
        </h1>
        <p className="content-disclaimer">
          <em>
            *Stateroom images and features are samples only. Actual furniture,
            fixtures, colors and configurations may vary.
          </em>
        </p>
        {stateRooms && stateRooms.length ? (
          <>
            <div
              className={`equote-package-state-rooms-tables ${this.state.sizing}`}
            >
              {renderTables(
                stateRooms,
                {
                  brand,
                  currency,
                  currencySymbol: activePackage.currencySymbol,
                  currencySymbolPlacement:
                    activePackage.currencySymbolPlacement,
                  searchParameters,
                  openVirtualTour,
                  brandClassName
                },
                this.state.sizing,
                false
              )}
            </div>
            {/* For Medium screens down */}
            <EQuotePackageStateRoomsSlider
              stateRooms={renderTables(
                stateRooms,
                {
                  brand,
                  currency,
                  currencySymbol: activePackage.currencySymbol,
                  currencySymbolPlacement:
                    activePackage.currencySymbolPlacement,
                  searchParameters,
                  openVirtualTour,
                  brandClassName
                },
                this.state.sizing,
                true
              )}
            />
          </>
        ) : (
          <p className="equote-package-state-rooms--no-availability-text">
            No staterooms are currently available for this sailing
          </p>
        )}
        <em className="pricing-disclaimer">
          <TermsAndConditions />
        </em>
      </div>
    )
  }
}

export default EQuotePackageStateRooms
